import { useRouter } from 'next/router';
import { useAtomValue } from 'jotai';
import { Badge, Button, Icon, Stack, Text } from '@pairy/pds-react';
import React, { useMemo } from 'react';

import { userInfoAtom } from '@/state/user/atom';
import ProPlanUpgradeModal from '@/components/User/_components/common/ProPlanUpgradeModal';

import TopBanner from '../../TopBanner';

import Logo from './Logo';
import * as Styled from './index.styles';
import Navigation from './Navigation';

const Header = () => {
  const router = useRouter();
  const userInfo = useAtomValue(userInfoAtom);
  const userPlanName = userInfo?.subscriptionPlan?.name || 'Free';
  const [isOpen, setIsOpen] = React.useState(false);

  const isProPlus = useMemo(() => {
    return userInfo?.subscriptionPlan?.name === 'Pro Plus';
  }, [userInfo]);

  return (
    <>
      <Styled.Container direction="column">
        <TopBanner />
        <Styled.Wrapper>
          <Styled.Left>
            <Logo />
            <Navigation />
          </Styled.Left>
          <Stack gap={8} width="fit-content">
            <Button
              variant="viridian_300"
              paddingY={8}
              paddingX={16}
              leftIcon={<Icon icon="ph:sparkle-fill" size={19} />}
              onClick={() => router.push('/change-log')}
            >
              <span>v1.39.0</span>
            </Button>
            {!isProPlus && (
              <Button
                variant="skyblue_400"
                leftIcon={<Icon icon="ph:magic-wand-fill" size={19} />}
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                업그레이드
              </Button>
            )}
            <div>
              <Button
                variant="zinc_200"
                leftIcon={<Icon icon="ph:user-circle" size={19} />}
                paddingY={9}
                paddingX={16}
                color="zinc_400"
                onClick={() => router.push('/user/setting')}
              >
                <Styled.NameContainer>
                  {userInfo?.name}
                  <Badge
                    radius={4}
                    backgroundColor={
                      userPlanName === 'Pro Plus'
                        ? 'loyalblue_400'
                        : userPlanName === 'Pro'
                        ? 'skyblue_400'
                        : userPlanName === 'Basic'
                        ? 'viridian_400'
                        : 'zinc_400' // Free 또는 null
                    }
                    borderStyle="none"
                    paddingX={8}
                  >
                    <Text variant="sm-medium" color="white">
                      {userPlanName === 'Pro Plus'
                        ? 'Pro +'
                        : userPlanName || 'Free'}
                    </Text>
                  </Badge>
                </Styled.NameContainer>
              </Button>
            </div>
          </Stack>
        </Styled.Wrapper>
      </Styled.Container>
      {isOpen && (
        <ProPlanUpgradeModal
          onOpenChange={(open: boolean) => {
            setIsOpen(open);
          }}
        />
      )}
    </>
  );
};

export default Header;
